// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top-container {
  position: fixed;
  bottom: 100px; /* Aligned with chat button */
  right: 25px;   /* Positioned where chat button used to be */
  z-index: 2000000;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px) scale(0.8);
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
}

.scroll-to-top-container.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.scroll-to-top-button {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
  color: white;
  position: relative;
  transition: all 0.3s ease;
}

.scroll-to-top-container:hover .scroll-to-top-button {
  transform: scale(1.05) translateY(-3px);
  background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.5);
}

.scroll-up-icon {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.scroll-to-top-container:hover .scroll-up-icon {
  transform: translateY(-2px);
}

.scroll-tooltip {
  position: absolute;
  right: 65px; /* Tooltip displays on the left of the button since button is on the right */
  background: #1e293b;
  color: white;
  padding: 8px 15px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  transform: translateX(10px);
  transition: all 0.3s ease;
  pointer-events: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.scroll-to-top-container:hover .scroll-tooltip {
  opacity: 1;
  transform: translateX(0);
}

.scroll-tooltip::after {
  content: '';
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 6px 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent transparent #1e293b;
}

/* Mobile Adjustments */
@media (max-width: 480px) {
  .scroll-to-top-container {
    bottom: 120px;
    right: 15px;
    z-index: 2147483647;
  }

  .scroll-tooltip {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScrollToTopButton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa,EAAE,6BAA6B;EAC5C,WAAW,IAAI,4CAA4C;EAC3D,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,sCAAsC;EACtC,4DAA4D;EAC5D,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,4EAA4E;EACzF,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".scroll-to-top-container {\n  position: fixed;\n  bottom: 100px; /* Aligned with chat button */\n  right: 25px;   /* Positioned where chat button used to be */\n  z-index: 2000000;\n  cursor: pointer;\n  opacity: 0;\n  transform: translateY(20px) scale(0.8);\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  border: none;\n  background: transparent;\n  outline: none;\n  padding: 0;\n}\n\n.scroll-to-top-container.visible {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.scroll-to-top-button {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);\n  color: white;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.scroll-to-top-container:hover .scroll-to-top-button {\n  transform: scale(1.05) translateY(-3px);\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.5);\n}\n\n.scroll-up-icon {\n  font-size: 18px;\n  transition: transform 0.3s ease;\n}\n\n.scroll-to-top-container:hover .scroll-up-icon {\n  transform: translateY(-2px);\n}\n\n.scroll-tooltip {\n  position: absolute;\n  right: 65px; /* Tooltip displays on the left of the button since button is on the right */\n  background: #1e293b;\n  color: white;\n  padding: 8px 15px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  opacity: 0;\n  transform: translateX(10px);\n  transition: all 0.3s ease;\n  pointer-events: none;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.scroll-to-top-container:hover .scroll-tooltip {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.scroll-tooltip::after {\n  content: '';\n  position: absolute;\n  right: -6px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-width: 6px 0 6px 6px;\n  border-style: solid;\n  border-color: transparent transparent transparent #1e293b;\n}\n\n/* Mobile Adjustments */\n@media (max-width: 480px) {\n  .scroll-to-top-container {\n    bottom: 120px;\n    right: 15px;\n    z-index: 2147483647;\n  }\n\n  .scroll-tooltip {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
